module.exports = __webpack_public_path__ + "img/bgimg1.80fea326.png";